import { createActionGroup, props } from "@ngrx/store";
import { SuggestionState } from "./suggestions.state";


export const SuggestionsActions = createActionGroup({
  source: 'Popular In Your Country',
  events: {
    'Load Data': props<SuggestionState>()
  }
})